import { memo, type RefObject } from "react";
import type { Control } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { FormInput } from "@/components/ui/forms/formInputComponent/formInput.component";
import type { FormularioEntrarType } from "../loginGrupoFixo.schema";
import { LOGIN_FIELD_LABEL_CLASSNAME, LOGIN_TEXT_FIELD_CLASSNAME } from "../../loginForm.constants";

// --------------------------------- TYPES ---------------------------------
type SecaoSenhaEntrarJwtProps = {
	readonly control: Control<FormularioEntrarType>;
	readonly exibirSenha: boolean;
	readonly aoAlternarVisibilidade: () => void;
	readonly referenciaSenha: RefObject<HTMLInputElement | null>;
	readonly requerDoisFatores: boolean;
};

// ------------------------------- COMPONENT -------------------------------
function SecaoSenhaEntrarJwt({
	control,
	exibirSenha,
	aoAlternarVisibilidade,
	referenciaSenha,
	requerDoisFatores,
}: Readonly<SecaoSenhaEntrarJwtProps>) {
	if (requerDoisFatores) return null;

	return (
		<FormControl fullWidth className="space-y-1.5">
			<FormLabel htmlFor="password" className={LOGIN_FIELD_LABEL_CLASSNAME}>
				Senha
			</FormLabel>
			<FormInput<FormularioEntrarType>
				control={control}
				name="password"
				id="password"
				type={exibirSenha ? "text" : "password"}
				placeholder="Digite sua senha"
				className={LOGIN_TEXT_FIELD_CLASSNAME}
				leftIcon={
					<FuseSvgIcon size={14} className="text-[#99aabb]">
						lucide:lock
					</FuseSvgIcon>
				}
				rightIcon={
					<FuseSvgIcon size={16} className="text-[#99aabb]">
						{exibirSenha ? "lucide:eye-off" : "lucide:eye"}
					</FuseSvgIcon>
				}
				rightIconAriaLabel={exibirSenha ? "Ocultar senha" : "Mostrar senha"}
				onRightIconClick={aoAlternarVisibilidade}
				autoComplete="current-password"
				inputRef={referenciaSenha}
				size="small"
				upperCaseValue={false}
			/>
		</FormControl>
	);
}

export default memo(SecaoSenhaEntrarJwt);
